<template>
  <assign-personal-panel
    ref="panel"
    :config="tabConfig"
    :users-loading="usersLoading"
  />
</template>

<script>
import AssignPersonalPanel from '../AssignPersonalPanel.vue'

const tabConfig = {
  endpoint: '/iso/technical-reviewers',
  // Enables the extra "Scope code" select (technical reviewers only)
  scopeCodesEndpoint: 'iso/scope-codes',
  memberPlural: 'technical reviewers',
  addTitle: 'Add technical reviewer',
  addHint: 'Select a user and a scope code, then add them to the technical review team',
  listTitle: 'Technical reviewers list',
  emptyTitle: 'No technical reviewers yet',
  emptySearchTitle: 'No matching technical reviewers',
  emptyHint: 'Add your first technical reviewer above.',
  removeButtonTitle: 'Remove technical reviewer',
  loadError: 'Failed to load technical reviewers',
  addError: 'Failed to add technical reviewer',
  addSuccess: 'Technical reviewer added successfully',
  removeTitle: 'Remove this technical reviewer?',
  removeSuccess: 'Technical reviewer removed',
  removeError: 'Failed to remove technical reviewer',
}

export default {
  name: 'TechnicalReviewersTab',
  components: {
    AssignPersonalPanel,
  },
  props: {
    usersLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabConfig,
    }
  },
  methods: {
    fetchMembers() {
      return this.$refs.panel?.fetchMembers()
    },
  },
}
</script>
